import { cn } from '@/lib/cn'

/**
 * e1 surface. `min-w-0` lets a card shrink inside grid/flex tracks at 320 px instead of
 * pushing the page sideways; a card whose direct child is a table scrolls that table
 * horizontally inside itself (design §10: the page never scrolls sideways).
 */
export function Card({
  className,
  id,
  children,
}: {
  className?: string
  /** an anchor to focus or scroll to (an empty list's «Новый промокод» focuses the form) */
  id?: string
  children: React.ReactNode
}) {
  return (
    <div
      id={id}
      className={cn(
        'min-w-0 rounded-md border border-hairline bg-surface-1 p-4 print:break-inside-avoid',
        '[&:has(>table)]:overflow-x-auto',
        className,
      )}
    >
      {children}
    </div>
  )
}

/** KPI tile. The number steps down from display-2 to title-1 below 640 px. Money values are
 *  long ("12 845 300,00"), so KPI grids go one tile per row below `sm` and at most 3–4 per row
 *  on desktop (Dashboard, Accounting); `overflow-wrap: anywhere` is only the last resort
 *  against a page scrolling sideways, never the layout. */
export function StatCard({
  label,
  value,
  title,
  hint,
}: {
  label: string
  /** already formatted (lib/format.ts): «128 430», «12 845 300,00» */
  value: string
  /** the exact value, when `value` is rounded (USDT shows 2 of its 6 decimals) */
  title?: string
  /** what the number covers, caption ink-3: «за всё время», «за 24 часа» */
  hint?: string
}) {
  return (
    <Card>
      <div className="text-caption text-ink-2">{label}</div>
      <div
        className="tnum mt-2 text-title-1 text-ink-1 [overflow-wrap:anywhere] sm:text-display-2"
        title={title}
      >
        {value}
      </div>
      {hint && <div className="mt-1 text-caption text-ink-3">{hint}</div>}
    </Card>
  )
}
